// src/Cn.tsx
import { createIcon } from "@chakra-ui/icon";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
var Cn_default = createIcon({
  displayName: "Cn",
  viewBox: "0 0 50 34",
  path: /* @__PURE__ */ jsxs(Fragment, {
    children: [
      /* @__PURE__ */ jsx("rect", {
        id: "red",
        x: "1",
        y: "1",
        width: "48",
        height: "32",
        fill: "#FF1A26"
      }),
      /* @__PURE__ */ jsx("path", {
        id: "Star 5",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.5 16.5L6.0916 19.5676L7.64682 14.4271L3.36707 11.1824L8.73663 11.0729L10.5 6L12.2633 11.0729L17.6329 11.1824L13.3532 14.4271L14.9084 19.5676L10.5 16.5Z",
        fill: "#FBB43A"
      }),
      /* @__PURE__ */ jsx("path", {
        id: "Star 5_2",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M18.7264 7.75167L17.342 8.1183L18.2005 6.972L17.424 5.76859L18.7795 6.23091L19.6841 5.12053L19.6633 6.55256L20.9988 7.06972L19.6304 7.49245L19.5513 8.92244L18.7264 7.75167Z",
        fill: "#FBB43A"
      }),
      /* @__PURE__ */ jsx("path", {
        id: "Star 5_3",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M23.4 11.5949L22.7909 12.8911L22.4647 11.4966L21.0437 11.3179L22.2692 10.5767L22 9.17004L23.0836 10.1065L24.3383 9.4158L23.7825 10.7358L24.8271 11.7156L23.4 11.5949Z",
        fill: "#FBB43A"
      }),
      /* @__PURE__ */ jsx("path", {
        id: "Star 5_4",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M22.8611 16.8846L21.5613 17.4861L22.2078 16.2081L21.2341 15.1578L22.6493 15.3778L23.3473 14.1272L23.5755 15.5411L24.9805 15.8184L23.7063 16.4724L23.8767 17.8944L22.8611 16.8846Z",
        fill: "#FBB43A"
      }),
      /* @__PURE__ */ jsx("path", {
        id: "Star 5_5",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M18.7264 20.7517L17.342 21.1183L18.2005 19.972L17.424 18.7686L18.7795 19.2309L19.6841 18.1205L19.6633 19.5526L20.9988 20.0697L19.6304 20.4924L19.5513 21.9224L18.7264 20.7517Z",
        fill: "#FBB43A"
      }),
      /* @__PURE__ */ jsx("path", {
        d: "M1 1V0H0V1H1ZM49 1H50V0H49V1ZM49 33V34H50V33H49ZM1 33H0V34H1V33ZM1 2H49V0H1V2ZM48 1V33H50V1H48ZM49 32H1V34H49V32ZM2 33V1H0V33H2Z",
        fill: "#F3F6F9"
      })
    ]
  })
});

export {
  Cn_default
};
